export const locale = {
    lang: "en-US",
    data: {
        ADD_CREDIT_CARD: {
            TITLE: "Add New Credit Card",
            NUMBER: {
                LABEL: "Card Number",
                ERROR: "Invalid Card Number"
            },
            HOLDER: {
                LABEL: "Name on Card",
                ERROR: "Invalid Name on Card"
            },
            EXPIRY: {
                LABEL: "Expiration Date",
                PLACE_HOLDER: "MM/YY",
                ERROR: "Invalid Expiration Date"
            },
            SECURITY_CODE: {
                LABEL: "CVV",
                ERROR: "Invalid CVV"
            },
            PHONE: {
                LABEL: "Phone",
                ERROR: "Invalid Phone Number"
            },
            ADD_BUTTON: "Save",
            IS_DEFAULT: "Use as Default",
            CANCEL_BUTTON: "Cancel"
        }
    }
};
